import React from 'react'
import "./Navbar.css"
const Navbar = () => {
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">K</a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarScroll"
                        aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarScroll">
                        <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll --bs-scroll-height: 100px;">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="#">HOME</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="https://www.euttaranchal.com/culture.php">CULTURE</a>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarScrollingDropdown" role="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Contact
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link disabled" href="https://www.euttaranchal.com/culture.php" tabindex="-1"
                                    aria-disabled="true">SHOP</a>
                            </li>
                        </ul>
                        <form className="d-flex">
                            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                            <button className="btn btn-outline-success" type="submit">search</button>
                        </form>
                    </div>
                </div>
            </nav>
            <div class=" text-uppercase text-centre display-3 a">
                <h1> kEthnic </h1>
            </div>
        </div>
    )
}

export default Navbar
